import { NodeDetailsDto } from "../components/common/NodeDetailsDto";
import { SearchHierarchyNodeResponse } from "./node-service";

export type MappedSearchHierarchyNodeResponse = {
    hierarchyNodes: SearchHierarchyNodeResponse[];
    nestedHierarchyNodes: NestedHierarchyNode[];
};

export type NestedHierarchyNode = {
    id: number;
    parentId?: number;
    name: string;
    reference: string;
    allowPartitionChildren: boolean;
    children?: NestedHierarchyNode[];
};

export function getMappedSearchHierarchyNodeResponse(
    searchHierarchyNodeResponse: SearchHierarchyNodeResponse[]
): MappedSearchHierarchyNodeResponse {
    const searchHierarchyNodeResponseCopy = searchHierarchyNodeResponse;

    const nestedHierarchyNodes = mapToNestedHierarchyNodes(searchHierarchyNodeResponseCopy);

    const mappedSearchHierarchyNodeResponse: MappedSearchHierarchyNodeResponse = {
        hierarchyNodes: searchHierarchyNodeResponse,
        nestedHierarchyNodes: nestedHierarchyNodes
    };

    return mappedSearchHierarchyNodeResponse;
}

export function getNodeById(nodeId: string, flatStructure: SearchHierarchyNodeResponse[]): NodeDetailsDto | undefined {
    const node = flatStructure.find((x) => x.id.toString() === nodeId);

    if (node) {
        const nodeDetails: NodeDetailsDto = {
            id: node.id,
            parentId: node.parentId,
            allowPartitions: node.allowPartitionChildren,
            name: node.name,
            reference: node.reference,
            hasChildren: flatStructure.filter((x) => x.parentId === node.id).length > 0,
        };

        return nodeDetails;
    }
}

const mapToNestedHierarchyNodes = (searchHierarchyNodeResponse: SearchHierarchyNodeResponse[]): NestedHierarchyNode[] => {
    const nestedHierarchyNodeParents = getParents(null, searchHierarchyNodeResponse);

    addChildren(nestedHierarchyNodeParents, searchHierarchyNodeResponse);

    return nestedHierarchyNodeParents;
};

const getParents = (
    id: number | null,
    searchHierarchyNodeResponse: SearchHierarchyNodeResponse[]
): NestedHierarchyNode[] => {
    const parents = searchHierarchyNodeResponse.filter((x) => x.parentId == id);

    const nestedHierarchyNodes: NestedHierarchyNode[] = [];

    for (let index = 0; index < parents.length; index++) {
        const parent = parents[index];
        const nestedHierarchyNode: NestedHierarchyNode = {
            id: parent.id,
            name: parent.name,
            parentId: parent.parentId,
            reference: parent.reference,
            allowPartitionChildren: parent.allowPartitionChildren,
            children: [],
        };
        nestedHierarchyNodes.push(nestedHierarchyNode);
    }

    return nestedHierarchyNodes;
};

const getChildren = (
    parent: NestedHierarchyNode,
    searchHierarchyNodeResponse: SearchHierarchyNodeResponse[]
): NestedHierarchyNode[] => {
    const parents = getParents(parent.id, searchHierarchyNodeResponse);

    addChildren(parents, searchHierarchyNodeResponse);

    return parents;
};

const addChildren = (
    parents: NestedHierarchyNode[],
    searchHierarchyNodeResponse: SearchHierarchyNodeResponse[]
): NestedHierarchyNode[] => {
    for (let index = 0; index < parents.length; index++) {
        const parent = parents[index];

        const children = getChildren(parent, searchHierarchyNodeResponse);

        for (let innerIndex = 0; innerIndex < children.length; innerIndex++) {
            const child = children[innerIndex];
            parent.children?.push(child);
        }
    }
    return parents;
};
